module.exports = __webpack_public_path__ + "static/media/mass-result-poster.f7c95dfe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/screens/highDefinitionOptics/MassTest/mass-result-poster.jpg
// module id = 3635
// module chunks = 0